import React from "react";
import ComponentHeading from "../../../common/componentHeading/ComponentHeading";
import whatGemHealCanAddressImage from "../../../assets/whatGemHealCanAddressImage.svg";
import whatGemHealCanAddressCheckIcon from "../../../assets/whatGemHealCanAddressCheckIcon.svg";
import { whatGemHealCanAddressData } from "../../../helper/cardsData/gemHealMockData";

const WhatGemHealCanAddress = () => {
  return (
    <div className="bg-primaryColor/10">
      <div className="component-padding mx-auto max-w-screen-2xl">
        <ComponentHeading
          heading="What GemHeal Can Address"
          // subHeading="A range of UI modifications"
        />
        <div className="mt-8 lg:mt-12 lg:grid lg:grid-cols-2 lg:items-center lg:justify-items-center lg:gap-12">
          <img
            className=""
            src={whatGemHealCanAddressImage}
            alt="a girl is typing on desktop"
            loading="lazy"
          />
          <div className="mt-9 flex flex-col gap-6">
            {whatGemHealCanAddressData.map((item) => {
              return (
                <div key={item.heading}>
                  <div className="flex gap-2">
                    <img
                      className="h-7 w-7"
                      src={whatGemHealCanAddressCheckIcon}
                      alt="green checkmark"
                    />
                    <p className="text-xl font-semibold text-heading">
                      {item.heading}
                    </p>
                  </div>
                  <p className="mt-2 text-bodyText ">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatGemHealCanAddress;
